import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  name: [
    {...makeRule('请输入客户名称', 'string')},
  ],
  number: [
    {...makeRule('请输入客户编号', 'integer')},
  ],
  phone: [
    {...makeRule('请输入正确的手机号', 'string', 'blur', true), pattern: /^1[3-9][0-9]\d{8}$/},
  ],
  email: [
    {...makeRule('请输入邮箱', 'email')},
  ],
}
export let rechargeRules = {
  name: [
    {...makeRule('请输入客户名称', 'string')},
  ],
  amount: [
    {...makeRule('请输入正确的充值金额', 'number')},
  ],
  is_allow_invoice: [
    {...makeRule('请选择申请开票', 'integer')},
  ],
  imageurl: [
    {...makeRule('请上传转账证明', 'array')},
  ],
}

export let memberRules = {
  name: [
    {...makeRule('请输入用户名称', 'string')},
  ],
  password: [
    {...makeRule('请输入密码', 'string')},
  ],
  cellphone: [
    {...makeRule('请输入正确的手机号', 'string', 'blur', true), pattern: /^1[3-9][0-9]\d{8}$/},
  ],
  mail_address: [
    {...makeRule('请输入邮箱', 'email')},
  ],
  role: [
    {...makeRule('请选择是否激活', 'integer')},
  ],
}

export let memberUpdateRules = {
  name: [
    {...makeRule('请输入用户名称', 'string')},
  ],
  cellphone: [
    {...makeRule('请输入正确的手机号', 'string', 'blur', true), pattern: /^1[3-9][0-9]\d{8}$/},
  ],
  mail_address: [
    {...makeRule('请输入邮箱', 'email')},
  ],
  role: [
    {...makeRule('请选择是否激活', 'integer')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/teke-customer/tekeCustomer.rules.js